import { Component, OnInit, Inject, Input, ViewChild } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig} from '@angular/material/dialog';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { SocketService } from 'src/app/services/socket/socket.service';
import { AuthService } from 'src/app/services/auth-service/auth.service';
import { environment } from 'src/environments/environment';
import { CreateGraphComponent } from '../create-graph/create-graph.component';
import * as moment from 'moment';

@Component({
  selector: 'app-subject-map',
  templateUrl: './subject-map.component.html',
  styleUrls: ['./subject-map.component.scss']
})
export class SubjectMapComponent implements OnInit{

  createProjectMode = 102;
  projetNameOne: string = ''
  tagNameOne: string = '';
  addingTagMember = [];
  //tagListadded = [];
  tagMemberAffected = [];
  tagUserSelected = [];
  addingMember = [];
  hasMemberAdding = false;
  currentUser = null;
  subjects: any[] = [];
  projectUsers: any[] = [];
  allProjectUsers: any[] = [];
  project: any;
  idProjet = null;
  SubNum = 0;
  btntagclicked = false;
  searchTagContact: any;
  userStatus = [];
  isAdmin = false;
  isPrivate = false;
  hideHeader = false;
  updateHeader = false;
  contacts = [];
  deadline = null;
  @ViewChild('createGraphComponent', {static: false}) createGraphComponent: CreateGraphComponent;
  vibrantColors = [
    "#e7e0ff", 
    "#caf1ee", 
    "#fff0d3", 
    "#fbd8dc", 
    "#d8fdd2", 
    "#f4ded1", 
    "#d1e8ff", 
    "#cbf2ef"
  ];

  colorMap: Record<string, string> = {
    '#e7e0ff': '#5d45de', 
    '#caf1ee': '#008476', 
    '#fff0d3': '#9d6b2b', 
    '#fbd8dc': '#cd0635', 
    '#d8fdd2': '#1c8555', 
    '#f4ded1': '#855436', 
    '#d1e8ff': '#0060d3', 
    '#cbf2ef': '#008379'  
  };
  public minDate = new Date();

  constructor(
    public dialogRef: MatDialogRef<SubjectMapComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private authService: AuthService,
    private socketService: SocketService,
    private router: Router,
    private route: ActivatedRoute,
    public  dialog: MatDialog)   {
      this.project = data.project;
      this.allProjectUsers = data.projectUsers;
      this.projectUsers = data.projectUsers.map(item => item.user);
      this.subjects = data.subjects;
      this.idProjet = data.idProjet;
      this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
      this.SubNum = this.subjects.length;
      this.projetNameOne = this.project.libelle;
      this.isAdmin = data.isAdmin;
      this.isPrivate = this.project.isPrivate;
    }

    hideHeaderInterface(hide = false){
      this.updateHeader = hide;
      this.hideHeader = !this.hideHeader;
    }

    onProjectRenamed(newName: string) {
      this.projetNameOne = newName;
    }

    ngOnInit(): void {
      this.authService.getMyContacts(this.currentUser['compId']).subscribe(res => {
        this.contacts = this.contacts.concat(res['hydra:member']);
        this.contacts = this.contacts.sort(function (a, b) {
          if (a.fullName.toLowerCase() < b.fullName.toLowerCase()) { return -1; }
          if (a.fullName.toLowerCase() > b.fullName.toLowerCase()) { return 1; }
          return 0;
        })
      })
    }

    selectAllUsers(){
      this.addingTagMember = [];
      this.projectUsers.forEach((item) => this.addingTagMember.push(item));
    }
    deselectAllUsers(){
      this.addingTagMember = [];
    }

    onNoClick(): void {
      if (this.createProjectMode === 101) {
      this.createProjectMode = 102;
      
      this.dialogRef.removePanelClass('dialogmappingadd-container');
      this.dialogRef.addPanelClass('dialogmapping-container');
    } else if (this.createProjectMode === 102 && !this.hideHeader) {
        this.dialogRef.close();
    } else if (this.createProjectMode === 102 && this.createGraphComponent) {
      this.createGraphComponent.goBack();
      if(this.createGraphComponent.mode == 1) this.hideHeader = false;
    }
    }

    onDateSelected(event: any): void {
          const selectedDate = event.value; // ✅ utiliser event.value, pas event.target.value
    
          if (selectedDate) {
            // Format avec moment
            this.deadline = moment(selectedDate).format('DD-MM-YYYY').toLocaleString();
          }
    }

    darkenColor(bgColor: string) {
      if (!bgColor) return '#444';
      const key = bgColor.toLowerCase().substring(0, 7);
      return this.colorMap[key] || '#444'
    }

    createSubject(){
      this.createProjectMode = 101;
      this.dialogRef.removePanelClass('dialogmapping-container');
      this.dialogRef.addPanelClass('dialogmappingadd-container');
    }
      
    getAvatarlUrl(avatarLink){
      return environment.server_url+avatarLink;
    }

    addTagToProject(){
      var general = false;
      if(this.tagNameOne.trim() == "" || this.tagNameOne.trim().length == 0){
        alert("Veuillez entrer une mission");
        return;
      } 
      /*if(this.addingTagMember.length == 0 && !this.projectDetails.isPrivate){
        alert("Veuillez sélectionner au moins un membre avant de créer la mission.");
        return;
      }*/
      this.tagUserSelected = [];
      var tagUser = [];
      tagUser.push({"user":"/api/users/"+this.currentUser.id});
      if(this.project.isPrivate){
        for (var j = 0; j < this.projectUsers.length; j++) {
          if(this.projectUsers[j].id != this.currentUser.id) tagUser.push({"user":"/api/users/"+this.projectUsers[j].id});
        }
      } else {
        for (var i = 0; i < this.addingTagMember.length; i++) {
          tagUser.push({"user":"/api/users/"+this.addingTagMember[i].id});
        }
      }
      this.addingTagMember.map(item=> {
          //tagUser.push(item.id);
          this.tagUserSelected.push(item);
          this.tagMemberAffected.push(item);
      })
      this.authService.addTagToProject({
        libelle: this.tagNameOne,
        project: '/api/projects/'+this.project.id,
        isGeneral: false
      }, tagUser, this.deadline).then((res)=>{
        this.subjects.push(res);
        this.tagNameOne = "";
        this.addingTagMember = [];
        this.tagUserSelected = [];
        this.dialogRef.removePanelClass('dialogmappingadd-container');
        this.dialogRef.addPanelClass('dialogmapping-container');
        this.SubNum++;
        this.authService.obSubAdd.next(res);
        this.goBackOtherSub();
      }).catch(err=>{
        console.log(err)
      });
    }

    goBackOtherSub(){
      this.createProjectMode = 102;
    }

    
  scrollRight(container: HTMLElement) {
    container.scrollBy({ left: 100, behavior: 'smooth' });
  }

  scrollLeft(container: HTMLElement) {
    container.scrollBy({ left: -100, behavior: 'smooth' });
  }

  /*getRandomColor(): string {
    const randomIndex = Math.floor(Math.random() * this.vibrantColors.length);
    return this.vibrantColors[randomIndex];
  }*/

  getInitials(libelle: string): string {
    const words = libelle.split(' ');
    const getFirstChar = (word: string): string => {
      return word.trim().charAt(0).toUpperCase();  // Récupère le premier caractère du mot
    };
    const initials = words.slice(0, 2).map(word => getFirstChar(word)).join('');  // Joint avec un point

    return initials;
  }

  getFormattedName(member: { givenName: string; familyName: string }): string {
    const firstInitial = member.familyName.charAt(0).toUpperCase();
    return `${member.givenName} .${firstInitial}`;
  }

  fctCheckMemberTag(userInfo){ 
      if(this.addingTagMember && !this.addingTagMember.includes(userInfo)){
        this.fctAdMemberTag(userInfo);
      } else this.fctRemoveUserTag(userInfo);
    }

    fctAdMemberTag(userInfo){ 
      this.addingTagMember.push(userInfo);
      this.searchTagContact = "";
    }

    fctRemoveUserTag(userInfo){
      const index = this.addingTagMember.indexOf(userInfo);
      if (index > -1) {
        this.addingTagMember.splice(index, 1);
        delete this.userStatus[userInfo['id']];
        this.searchTagContact = "";
      }
    }
}